import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { Link, Route, withRouter, Switch, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import CaseInformation from "./CaseInformation";
import EnquirySubmission from "./EnquirySubmission";
import ArbitratorNotice from "./ArbitratorNotice";
import Grid from "@material-ui/core/Grid";
import Award from "./Award";
import Button from "@material-ui/core/Button";
import TeleConferencing from "./TeleConferencing";
import DocsList from "./DocsList";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import PrimaryAppBar from "../../components/PrimaryAppBar";
import Settlement from "./Settlement";
import Response from "./Response";
import CircularProgress from "@material-ui/core/CircularProgress";
import withSizes from "react-sizes";
import ChooseArbitratorForCaseInformation from "./ChooseArbitratorForCaseInformation";

import Footer from "../Footer/Footer";

import searchBtn from "../../../src/images/searchBtn.png";
import awardBtn from "../../../src/images/awardBtn.png";
import settlementBtn from "../../../src/images/settlementBtn.png";
import responseBtn from "../../../src/images/responseBtn.png";
import uploadDocBtn from "../../../src/images/uploadDocBtn.png";
import arbitrationNoticeBtn from "../../../src/images/arbitrationNoticeBtn.png";
import caseInfoBtn from "../../../src/images/caseInfoBtn.png";
import appointArbitrator from "../../../src/images/appointArbitrator.png"; 

import searchBtnEng from "../../../src/images/searchBtnEng.png";
import awardBtnEng from "../../../src/images/awardBtnEng.png";
import settlementBtnEng from "../../../src/images/settlementBtnEng.png";
import responseBtnEng from "../../../src/images/responseBtnEng.png";
import uploadDocBtnEng from "../../../src/images/uploadDocBtnEng.png";
import arbitrationNoticeBtnEng from "../../../src/images/arbitrationNoticeBtnEng.png";
import caseInfoBtnEng from "../../../src/images/caseInfoBtnEng.png";
import appointArbitratorEng from "../../../src/images/appointArbitratorEng.png"; 
import MainPanelDesktop from './MainPanel/MainPanelDesktop';
import MainPanelMobile from './MainPanel/MainPanelMobile';

const styles = (theme) => ({
  isMobileFormControl: {
    marginLeft: "auto",
    marginRight: "auto",
  },
  active_tabStyle: {
    color: "white",
    backgroundColor: "#B71C1C",
    outline: "0",
  },
  root: {
    width: "100vw",
    '@media (max-width: 576px)': {
        width: '100%'
    }
  },
  [theme.breakpoints.down("xs")]: {
    tabLabel: {
      fontSize: 12,
    },
  },
  [theme.breakpoints.up("sm")]: {
    tabLabel: {
      fontSize: 12,
    },
  },
  [theme.breakpoints.up("md")]: {
    tabLabel: {
      fontSize: 12,
    },
  },
  btn:{
      marginBottom:'10px'
  },
  btnimg:{
      width:'100%'
  },
  gri:{
  }
});

class MainPanelHome extends Component {

  render() {
        const { 
          classes,
          history,
          location,
          match,
          isLoading,
          newAccount,

          typeOfAccount,
          isMobile,
          windowWidth,
          value,
          lang,
          caseData,
          isDesktop,
          claimant_docs,
          respondent_docs,
          admin_docs,
          userType,
          handleChange
         } = this.props;

        return (
            <>
                {
                    isLoading ? 
                        (<CircularProgress size={50} thickness={3} className={classes.progress}/>) : 
                        (
                                (newAccount !== null && newAccount !== undefined && newAccount) ? 
                                    (<Redirect to={`/cases/${match.params.id}/OnBoarding`} />) : 
                                    (
                                        (isDesktop) ? 
                                        <div className={classes.root}>
                                            <MainPanelDesktop 
                                              typeOfAccount={typeOfAccount}
                                              isMobile={isMobile}
                                              windowWidth={windowWidth}
                                              handleChange={handleChange}
                                              value={value}
                                              lang={lang}
                                              caseData={caseData}
                                              isDesktop={isDesktop}
                                              claimant_docs={claimant_docs}
                                              admin_docs={admin_docs}
                                              respondent_docs={respondent_docs}
                                              userType={userType}
                                              match={match}
                                              history={history}
                                            /> 
                                        </div>: 
                                        <div className={classes.root}>
                                            <MainPanelDesktop 
                                              typeOfAccount={typeOfAccount}
                                              isMobile={isMobile}
                                              windowWidth={windowWidth}
                                              handleChange={handleChange}
                                              value={value}
                                              lang={lang}
                                              caseData={caseData}
                                              isDesktop={isDesktop}
                                              claimant_docs={claimant_docs}
                                              admin_docs={admin_docs}
                                              respondent_docs={respondent_docs}
                                              userType={userType}
                                              match={match}
                                              history={history}
                                            />
                                        </div>
                                    )
                            
                        )
                }
            </>
        )
        
    }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCaseInfo: (caseId, uniqueId) =>
      dispatch(actions.getCaseInfo(caseId, uniqueId)),
    getUserInformation: (uniqueId) =>
      dispatch(actions.getUserInformation(uniqueId)),
  };
};

const mapSizesToProps = (sizes) => ({
  isMobile: withSizes.isMobile(sizes),
  isTablet: withSizes.isTablet(sizes),
  isDesktop: withSizes.isDesktop(sizes),
  isGtMobile: withSizes.isGtMobile(sizes),
  isGtTablet: withSizes.isGtTablet(sizes),
  isStTablet: withSizes.isStTablet(sizes),
  isStDesktop: withSizes.isStDesktop(sizes),
  isTabletAndGreater: withSizes.isTabletAndGreater(sizes),
  isTabletAndSmaller: withSizes.isTabletAndSmaller(sizes),
});

MainPanelHome.contextTypes = {
  t: PropTypes.func,
};

export default connect( mapStateToProps, mapDispatchToProps)(withSizes(mapSizesToProps)(withStyles(styles)(MainPanelHome)));
